import React, { ReactElement } from 'react';
import styles from './IconCategoryWrapper.module.scss';
import classNames from 'classnames';
import { IconCategory } from '../IconCategoryBrowse';

export interface WrapperProps {
    cards: IconCategory[];
    children: (arg: IconCategory, index?: number) => ReactElement;
    noScrollMobile?: boolean;
}

export const IconCategoryWrapper = (props: WrapperProps): ReactElement => {
    const { cards, children } = props;
    return (
        <div className={classNames(styles.root)}>
            {cards.map((cards, index) => children(cards, index))}
        </div>
    );
};
